module.exports = new __parcel__URL__("okay.5449a9ba.mp3").toString();